export default "__VITE_PUBLIC_ASSET__b612f18d__"